import React from 'react'
import { ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap'
import Resx from '@/components/Resx'
import { DatePicker } from '@/components/DatePicker'
import CheckBox from '@/components/CheckBox'
import Icon from '@/components/Icon'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import moment from 'moment'

const initialState = {
  name: '',
  recurring: false
}

class CreateNewReportingHolidaysDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      ...initialState,
      date: moment({ year: props.year.number, month: 0, day: 1 })
    }
  }
  handleNameChange = (e) => {
    this.setState({ name: e.target.value })
  }
  handleDateChange = (date) => {
    this.setState({ date })
  }
  handleRecurringChange = (recurring) => {
    this.setState({ recurring })
  }
  render () {
    const { year } = this.props
    const canAdd = this.state.name.length > 0 && this.state.date != null
    return (
      <React.Fragment>
        <BasicHeader title='Reporting.NewHoliday' {...this.props} />
        <ModalBody>
          <Form>
            <FormGroup>
              <Label><Resx name='Common.Name' /></Label>
              <Input value={this.state.name} onChange={this.handleNameChange} />
            </FormGroup>
            <FormGroup>
              <Label><Resx name='Reporting.Date' /></Label>
              <DatePicker
                value={this.state.date}
                onChange={this.handleDateChange}
                min={moment({ year: year.number, month: 0, day: 1 })}
                max={moment({ year: year.number, month: 11, day: 31, hour: 23, minute: 59, second: 59 })} />
            </FormGroup>
            <FormGroup>
              <CheckBox title='Reporting.Recurring'
                checked={this.state.recurring || false}
                onChange={this.handleRecurringChange} />
            </FormGroup>
          </Form>
        </ModalBody>

        <ModalFooter>
          <Button color='primary' disabled={!canAdd} onClick={() => this.props.onAction({ ...this.state })}><Icon name='plus' /><Resx name='Common.Add' /></Button>
        </ModalFooter>
      </React.Fragment>
    )
  }
}

export default {
  component: CreateNewReportingHolidaysDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/newReportingHolidays.js